import Company from './Company'

export default class Label {
  constructor() {
    this.name = ''
    this.color = ''
    this.company_id = ''
    this.company = new Company
  }
}
